export default __webpack_public_path__ + "static/PPMori-Regular-e647e964441593fd7fdf9a4d076f0808.otf";